export const paypalEmail = 'info@dpsrescue.com';
export const donateEmail = 'info@dpsrescue.com';
export const donateLink = 'https://www.zeffy.com/donation-form/donate-to-help-save-lives-2';
export const paypalLink = 'https://www.paypal.com/donate/?hosted_button_id=JYKGZV458ZS2N#';
